import React, { Component } from "react"
import { Button, Card, CardBody, Col } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import {
  registerUser,
  registerUserFailed,
} from "../../store/auth/register/actions"
import { getDashboardData } from "../../store/dashboard/actions"
import { apiError } from "../../store/auth/login/actions"
import Loader from "react-loader-spinner"
import { setUserPreference } from "../../store/auth/profile/actions"
import { withTranslation } from "react-i18next"
import Tooltip from "../../components/Common/tooltip"
import { describeDate, describeMoney } from "../../helpers/utils"

class VendasCanalTemporal extends Component {
  constructor(props) {
    super(props)

    const notFound = props.t("dashboard.list.vendasCanalTemporal.notFound")

    this.state = {
      metricaType:
        props.preferences &&
        props.preferences.Grafico_Vendas_Canal_Temporal_Metrica
          ? props.preferences.Grafico_Vendas_Canal_Temporal_Metrica
          : "ticketMedio",
      granularidadeType:
        props.preferences &&
        props.preferences.Grafico_Vendas_Canal_Temporal_Granularidade
          ? props.preferences.Grafico_Vendas_Canal_Temporal_Granularidade
          : "dia",
      translation: {
        title: props.t("dashboard.list.vendasCanalTemporal.title"),
        tooltip: props.t("dashboard.list.vendasCanalTemporal.tooltip"),
        month: props.t("dashboard.list.vendasCanalTemporal.month"),
        day: props.t("dashboard.list.vendasCanalTemporal.day"),
        week: props.t("dashboard.list.vendasCanalTemporal.week"),
        billing: props.t("dashboard.list.vendasCanalTemporal.billing"),
        ticket: props.t("dashboard.list.vendasCanalTemporal.ticket"),
        notFound,
        billingType: props.t("dashboard.list.vendasCanalTemporal.billingType"),
        ticketType: props.t("dashboard.list.vendasCanalTemporal.ticketType"),
        noData: props.t("dashboard.list.vendasCanalTemporal.noData"),
      },
      canais: {
        SALAO: {
          name: props.t("dashboard.lista.valorCanal.SALAO.title"),
          color: "#556ee6",
        },
        BALCAO: {
          name: props.t("dashboard.lista.valorCanal.BALCAO.title"),
          color: "#34c38f",
        },
        DELIVERY: {
          name: props.t("dashboard.lista.valorCanal.DELIVERY.title"),
          color: "#f8b425",
        },
        TOTEM: {
          name: props.t("dashboard.lista.valorCanal.TOTEM.title"),
          color: "#f46a6a",
        },
      },
      series: [],
      options: {
        chart: {
          type: "line",
          height: 300,
          toolbar: { show: false },
        },
        dataLabels: { enabled: false },
        stroke: { curve: "smooth", width: 3 },
        colors: ["#556ee6", "#34c38f", "#f8b425", "#f46a6a"],
        xaxis: {
          categories: [],
          title: { text: "Data" },
        },
        yaxis: {
          title: { text: "Ticket Médio (R$)" },
          labels: {
            formatter: function (val) {
              return `R$ ${parseFloat(val || 0).toFixed(2)}`
            },
          },
        },
        grid: { borderColor: "#f1f1f1" },
        legend: { show: true, position: "bottom" },
        noData: { text: notFound },
      },
    }
  }

  static abbreviateNumber(num, fixed) {
    if (num === null) {
      return null
    }
    if (num === 0) {
      return "0"
    }
    fixed = !fixed || fixed < 0 ? 0 : fixed
    var b = num.toPrecision(2).split("e"),
      k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3),
      c =
        k < 1
          ? num.toFixed(0 + fixed)
          : (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
      d = c < 0 ? c : Math.abs(c),
      e = d + ["", "K", "M", "B", "T"][k]
    return e
  }

  static formatDataLabel = (data, granularidadeType) => {
    if (!data) return ""

    if (granularidadeType === "semana") {
      const diasSemana = [
        "Segunda",
        "Terça",
        "Quarta",
        "Quinta",
        "Sexta",
        "Sábado",
        "Domingo",
      ]
      return diasSemana[data] || data
    } else if (granularidadeType === "mes") {
      const meses = [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ]
      return meses[data - 1] || data
    }

    return data
  }

  static updateChartData = (dashboardData, current_state) => {
    if (dashboardData !== undefined) {
      let dadosPeriodo = dashboardData || []

      const canaisDados = {}
      const labelsDatas = new Set()

      dadosPeriodo.forEach(item => {
        if (!canaisDados[item.Canal]) {
          canaisDados[item.Canal] = []
        }
        canaisDados[item.Canal].push(item)
        labelsDatas.add(item.Data)
      })

      const sortedDatas = Array.from(labelsDatas).sort()

      const series = Object.keys(current_state.canais).map(canal => {
        const canalData = canaisDados[canal] || []
        const data =
          sortedDatas.length > 0
            ? sortedDatas.map(data => {
                const item = canalData.find(d => d.Data === data)
                if (!item) return 0

                return current_state.metricaType === "ticketMedio"
                  ? item.Ticket_Medio || 0
                  : item.Valor_Total || 0
              })
            : []

        return {
          name: current_state.canais[canal].name,
          data: data,
          color: current_state.canais[canal].color,
        }
      })

      const categories =
        sortedDatas.length > 0
          ? sortedDatas.map(data =>
              current_state.granularidadeType === "dia"
                ? describeDate(data, "DD/MM")
                : VendasCanalTemporal.formatDataLabel(
                    data,
                    current_state.granularidadeType
                  )
            )
          : []

      const options = {
        chart: {
          type: "line",
          height: 300,
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        colors: Object.values(current_state.canais).map(c => c.color),
        xaxis: {
          categories: categories,
          title: {
            text:
              current_state.granularidadeType === "dia"
                ? "Data"
                : current_state.granularidadeType === "semana"
                ? "Dia da Semana"
                : current_state.translation.month,
          },
        },
        yaxis: {
          title: {
            text:
              current_state.metricaType === "ticketMedio"
                ? current_state.translation.ticketType
                : current_state.translation.billingType,
          },
          labels: {
            formatter: function (val) {
              if (current_state.metricaType === "ticketMedio") {
                return describeMoney(val || 0)
              } else {
                return `R$ ${VendasCanalTemporal.abbreviateNumber(val)}`
              }
            },
          },
        },
        grid: {
          borderColor: "#f1f1f1",
        },
        tooltip: {
          x: {
            show: true,
            formatter: function (val, opts) {
              return categories[opts.dataPointIndex] || "Sem data"
            },
          },
          y: {
            formatter: function (val, { seriesIndex, dataPointIndex }) {
              if (dadosPeriodo.length === 0) return "Sem dados"

              const canal = Object.keys(current_state.canais)[seriesIndex]
              const dataItem = dadosPeriodo.find(
                d => d.Canal === canal && sortedDatas[dataPointIndex] === d.Data
              )

              if (!dataItem) return "Sem dados"

              const ticketMedio = dataItem.Ticket_Medio || 0
              const faturamento = dataItem.Valor_Total || 0
              const qtdAtendimentos = dataItem.Qtd_Vendas || 0

              return `
                <div>
                  <strong>Ticket Médio:</strong> R$ ${ticketMedio.toLocaleString(
                    "pt-BR",
                    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                  )}<br/>
                  <strong>Faturamento:</strong> R$ ${faturamento.toLocaleString(
                    "pt-BR"
                  )}<br/>
                  <strong>Nº Atendimentos:</strong> ${qtdAtendimentos}
                </div>
              `
            },
          },
        },
        legend: {
          show: true,
          position: "bottom",
        },
        markers: {
          size: 4,
          hover: {
            size: 6,
          },
        },
      }

      return {
        ...{ series, options },
      }
    }

    return {}
  }

  componentDidMount() {
    this.props.getDashboardData(
      this.props.dashboardFilters.periodStart,
      this.props.dashboardFilters.periodEnd,
      this.props.dashboardFilters.companiesId,
      "valoresPorCanalTemporal",
      { granularity: this.state.granularidadeType }
    )
  }

  static getDerivedStateFromProps(props, current_state) {
    const dashboard = VendasCanalTemporal.updateChartData(
      props.dashboardValoresPorCanalTemporal,
      current_state
    )
    return {
      ...props,
      ...dashboard,
    }
  }

  setMetricaType(metricaType) {
    this.setState(prevState => ({ ...prevState, metricaType }))
    this.props.setUserPreference(
      "Grafico_Vendas_Canal_Temporal_Metrica",
      metricaType
    )
  }

  setGranularidadeType(granularidadeType) {
    this.setState(prevState => ({ ...prevState, granularidadeType }))
    this.props.setUserPreference(
      "Grafico_Vendas_Canal_Temporal_Granularidade",
      granularidadeType
    )

    this.props.getDashboardData(
      this.props.dashboardFilters.periodStart,
      this.props.dashboardFilters.periodEnd,
      this.props.dashboardFilters.companiesId,
      "valoresPorCanalTemporal",
      { granularity: granularidadeType }
    )
  }

  render() {
    return (
      <React.Fragment>
        <Col xl="12">
          <Card>
            <CardBody>
              <div className="d-flex flex-wrap">
                <h4 className="card-title mb-4">
                  {this.state.translation.title}
                </h4>
                <Tooltip
                  id="vendascanaltemopral"
                  tooltip={this.state.translation.tooltip}
                ></Tooltip>
                <div className="ms-auto">
                  <div className="toolbar d-flex flex-wrap gap-2 text-end">
                    <div className="btn-group" role="group">
                      <Button
                        color="light"
                        size="sm"
                        type="button"
                        className={
                          this.state.metricaType === "ticketMedio"
                            ? "active"
                            : ""
                        }
                        onClick={() => this.setMetricaType("ticketMedio")}
                      >
                        {this.state.translation.ticket}
                      </Button>
                      <Button
                        color="light"
                        size="sm"
                        type="button"
                        className={
                          this.state.metricaType === "faturamento"
                            ? "active"
                            : ""
                        }
                        onClick={() => this.setMetricaType("faturamento")}
                      >
                        {this.state.translation.billing}
                      </Button>
                    </div>

                    <div className="btn-group" role="group">
                      <Button
                        color="light"
                        size="sm"
                        type="button"
                        className={
                          this.state.granularidadeType === "dia" ? "active" : ""
                        }
                        onClick={() => this.setGranularidadeType("dia")}
                      >
                        {this.state.translation.day}
                      </Button>
                      <Button
                        color="light"
                        size="sm"
                        type="button"
                        className={
                          this.state.granularidadeType === "semana"
                            ? "active"
                            : ""
                        }
                        onClick={() => this.setGranularidadeType("semana")}
                      >
                        {this.state.translation.week}
                      </Button>
                      <Button
                        color="light"
                        size="sm"
                        type="button"
                        className={
                          this.state.granularidadeType === "mes" ? "active" : ""
                        }
                        onClick={() => this.setGranularidadeType("mes")}
                      >
                        {this.state.translation.month}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              {this.props.loadingDashboardValoresPorCanalTemporal ? (
                <div className="loader-container position-absolute">
                  <Loader
                    type="ThreeDots"
                    color="#556EE6"
                    height={80}
                    width={80}
                  />
                </div>
              ) : (
                <div>
                  <ReactApexChart
                    options={this.state.options}
                    series={this.state.series}
                    type="line"
                    height={300}
                  />
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
    )
  }
}

VendasCanalTemporal.propTypes = {
  loadingDashboardValoresPorCanalTemporal: PropTypes.any,
  dashboards: PropTypes.any,
  getDashboardData: PropTypes.func,
}

const mapStatetoProps = state => {
  const {
    loadingDashboardValoresPorCanalTemporal,
    dashboardValoresPorCanalTemporal,
  } = state.Dashboard
  const { dashboardData, dashboardFilters, dashboards, preferences } =
    state.Login
  return {
    dashboardData,
    dashboardFilters,
    dashboards,
    loadingDashboardValoresPorCanalTemporal,
    dashboardValoresPorCanalTemporal,
    preferences,
  }
}

export default withTranslation()(
  connect(mapStatetoProps, {
    registerUser,
    apiError,
    registerUserFailed,
    getDashboardData,
    setUserPreference,
  })(VendasCanalTemporal)
)
